import * as React from "react"
import createSvgIcon from "./utils/create_icon"

const FacebookFill = createSvgIcon(<path clipRule="evenodd" d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm1.045-9.474V18h-2.203v-5.474H9v-2.133h1.842V8.82c0-1.826 1.115-2.82 2.744-2.82.78 0 1.45.058 1.646.084v1.908h-1.13c-.886 0-1.057.421-1.057 1.04v1.361h2.112l-.275 2.133z" fill="currentColor" fillRule="evenodd" />, "FacebookFill")
export default FacebookFill
